export const SUMMARY_FETCH_DELIVERABLES_BEGIN = 'SUMMARY_FETCH_DELIVERABLES_BEGIN';
export const SUMMARY_FETCH_DELIVERABLES_SUCCESS = 'SUMMARY_FETCH_DELIVERABLES_SUCCESS';
export const SUMMARY_FETCH_DELIVERABLES_FAILURE = 'SUMMARY_FETCH_DELIVERABLES_FAILURE';
export const SUMMARY_FETCH_DELIVERABLES_DISMISS_ERROR = 'SUMMARY_FETCH_DELIVERABLES_DISMISS_ERROR';
export const SUMMARY_FETCH_CONTROL_ACCOUNTS_BEGIN = 'SUMMARY_FETCH_CONTROL_ACCOUNTS_BEGIN';
export const SUMMARY_FETCH_CONTROL_ACCOUNTS_SUCCESS = 'SUMMARY_FETCH_CONTROL_ACCOUNTS_SUCCESS';
export const SUMMARY_FETCH_CONTROL_ACCOUNTS_FAILURE = 'SUMMARY_FETCH_CONTROL_ACCOUNTS_FAILURE';
export const SUMMARY_FETCH_CONTROL_ACCOUNTS_DISMISS_ERROR = 'SUMMARY_FETCH_CONTROL_ACCOUNTS_DISMISS_ERROR';



// WEBPACK FOOTER //
// ./src/features/summary/redux/constants.js